// Random content is chosen once per page load, independently of placement.
(function () {
  var mobile=matchMedia('(max-width:900px)');
  function init(root){
    root.querySelectorAll('.goods').forEach(function(grid){
      grid.querySelectorAll(':scope > .promocard:not([data-promo-ready])').forEach(function(slot){
        slot.dataset.promoReady='true';
        if(window.Shopify && Shopify.designMode)return;
        if(slot.dataset.random==='true'){
          var products=Array.from(grid.children).filter(function(n){return n.matches('.card:not(.promocard)');});
          if(products.length>1)grid.insertBefore(slot,products[1+Math.floor(Math.random()*(products.length-1))]);
        }
        if(slot.dataset.promoMode!=='random')return;
        var original=slot.cloneNode(true),seed=Math.random();
        function choose(){
          var choices=[original];
          grid.querySelectorAll('template[data-promo-option]').forEach(function(t){
            var card=t.content.firstElementChild;
            if(card && !card.classList.contains(mobile.matches?'promo-no-mobile':'promo-no-desktop'))choices.push(card);
          });
          var content=choices[Math.floor(seed*choices.length)];
          slot.replaceChildren.apply(slot,Array.from(content.childNodes).map(function(n){return n.cloneNode(true);}));
          Array.from(slot.classList).filter(function(c){return c==='light'||c.indexOf('promo--')===0;}).forEach(function(c){slot.classList.remove(c);});
          Array.from(content.classList).filter(function(c){return c==='light'||c.indexOf('promo--')===0;}).forEach(function(c){slot.classList.add(c);});
        }
        mobile.addEventListener('change',choose);
        function unload(e){if(!e.target.contains(grid))return;mobile.removeEventListener('change',choose);document.removeEventListener('shopify:section:unload',unload);}
        document.addEventListener('shopify:section:unload',unload);choose();
      });
    });
  }
  window.wftBindPromos=init;init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  var observer=new MutationObserver(function(records){if(records.some(function(r){return Array.from(r.addedNodes).some(function(n){return n.nodeType===1 && (n.matches('.promocard')||n.querySelector('.goods'));});}))init(document);});
  observer.observe(document.body,{childList:true,subtree:true});
})();
